export function ClientsLogo() {
    const companyHighlights = [
        { highlight: "600+ Vehicles" }, 
        { highlight: "Since 2007" },
        { highlight: "24/7 Service" },
        { highlight: "Professional Drivers" },
        { highlight: "Airport Transfers" },
        { highlight: "Corporate Car Solutions" },
        { highlight: "Employee Transport" },
        { highlight: "Hyderabad Based" },
        { highlight: "Safety First" },
        { highlight: "Timely Service" }
    ];
    // Duplicate the highlights for infinite scroll effect (3 sets)
    const duplicatedHighlights = [...companyHighlights, ...companyHighlights, ...companyHighlights];

    return (
        <div>
            <div className="pt-6 pb-1">
                <h3 className="text-xs md:text-base font-semibold text-center mb-4">
                    PVR CABS: Best-in-Class IT Employee Transport – Safe. Punctual. Professional.
                </h3>

                {/* Desktop view - infinite scroll (8 columns) */}
                <div className="hidden md:block overflow-hidden py-2">
                    <div className="animate-infinite-scroll-desktop whitespace-nowrap">
                        {duplicatedHighlights.map((data, i) =>
                            <div key={`desktop-${i}`} className="inline-block w-fit px-20 py-4 border text-center rounded-md me-2.5 text-sm font-medium">
                                {data.highlight}
                            </div>
                        )}
                    </div>
                </div>

                {/* Mobile view - infinite scroll (4 columns) */}
                <div className="md:hidden overflow-hidden py-2">
                    <div className="animate-infinite-scroll-mobile whitespace-nowrap">
                        {duplicatedHighlights.map((data, i) =>
                            <div key={`mobile-${i}`} className="inline-block w-fit px-10 py-4 border text-center rounded-md me-2.5 text-xs font-medium">
                                {data.highlight}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <hr /><hr className="mt-[1px] border-2 border-blue-900/10" />
        </div>
    )
}